import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { usePageTitle } from "./usePageTitle";

export type PageHeaderProps = { title: string; description?: ReactNode; actions?: ReactNode; documentTitle?: string };

export default function PageHeader({ title, description, actions, documentTitle }: PageHeaderProps) {
  usePageTitle(documentTitle ?? title);
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 2, mb: 2 }}>
      <Box sx={{ flex: "1 1 260px", minWidth: 0 }}>
        <Typography component="h1" variant="h1" sx={{ color: "primary.main", fontSize: 22, fontWeight: 700 }}>{title}</Typography>
        {description && <Typography sx={{ color: "text.secondary", fontSize: 13 }}>{description}</Typography>}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>{actions}</Box>}
    </Box>
  );
}
